import React from 'react';
const MaxEditor = (props) => {
    const attribute = Object.assign({}, props);
    const stroke = attribute.stroke || '#7D8085';
    delete attribute.stroke;
    return (React.createElement("svg", Object.assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("path", { d: "M7.33333 14.0001H2V8.66675", stroke: stroke, strokeWidth: "1.2", fill: "none", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M8.66675 2H14.0001V7.33333", stroke: stroke, strokeWidth: "1.2", fill: "none", strokeLinejoin: "round" })));
};
export default MaxEditor;
